import React from "react";
import "./EnrollmentPhotoModal.css";
import type { EmployeeEnrollment } from "../../interfaces/SelfieEnrollment";
import { enrollmentReason } from "../../util/enrollmentReasons";

/** The slate enrollment spinner (motion, not colour, says "in flight"). */
export const EnmSpin: React.FC<{ lg?: boolean; light?: boolean }> = ({ lg, light }) => (
    <span className={`enm-spin${lg ? " lg" : ""}${light ? " light" : ""}`} aria-hidden="true" />
);

/**
 * Reason chip for a failed enrollment, or the outlined slate Verifying chip.
 * `family` adds the family line under it (rows, list modal).
 */
export const EnrollmentChip: React.FC<{ enrollment: EmployeeEnrollment; family?: boolean }> = ({
    enrollment,
    family,
}) => {
    if (enrollment.state === "verifying") {
        return (
            <span className="enm-chip s-verifying">
                <EnmSpin />
                Verifying
                {(enrollment.attempts ?? 1) > 1 && <span className="enm-att">try {enrollment.attempts} of 3</span>}
            </span>
        );
    }
    const m = enrollmentReason(enrollment.reason);
    const { Icon } = m;
    return (
        <>
            <span className={`enm-chip ${m.cls}`}>
                <Icon />
                {m.label}
            </span>
            {family && <span className="enm-fam">{m.family}</span>}
        </>
    );
};
